import { FC, ReactNode } from 'react';
import { Menu as MUIMenu, MenuProps } from '@mui/material';

export type AppMenuProps = MenuProps & {
  children?: ReactNode;
};

export const Menu: FC<AppMenuProps> = ({ children, ...props }) => {
  return (
    <MUIMenu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    >
      {children}
    </MUIMenu>
  );
};
